/**
 * Symbols for tags (docs/08-entscheidungen.md, S21): Lucide icons (https://lucide.dev, ISC licence),
 * as SVG paths in a box of 24, to be drawn as lines 2 wide with round ends. Made by
 * packages/web/tools/tag-icons.ts – change the choice there, not here.
 */
export interface TagIcon {
  id: string;
  label: string;
  d: string[];
}

export const TAG_ICONS: readonly TagIcon[] = [
  {
    "id": "flame",
    "label": "Scharf",
    "d": [
      "M12 3q1 4 4 6.5t3 5.5a1 1 0 0 1-14 0 5 5 0 0 1 1-3 1 1 0 0 0 5 0c0-2-1.5-3-1.5-5q0-2 2.5-4"
    ]
  },
  {
    "id": "vegan",
    "label": "Vegan",
    "d": [
      "M16 8q6 0 6-6-6 0-6 6",
      "M17.41 3.59a10 10 0 1 0 3 3",
      "M2 2a26.6 26.6 0 0 1 10 20c.9-6.82 1.5-9.5 4-14"
    ]
  },
  {
    "id": "leaf",
    "label": "Pflanzlich",
    "d": [
      "M11 20a10 10 0 0010-10 25.9 25.9 0 00-1.04-7.281 1 1 0 00-1.755-.325C15.833 5.5 13 5.5 9.8 6.1A7 7 0 0011 20",
      "M2 21a5 5 0 012.911-4.544C7.613 15.212 8.351 15.24 11 13"
    ]
  },
  {
    "id": "carrot",
    "label": "Vegetarisch",
    "d": [
      "M15 16a1 1 0 0 0-7-7q-4 4-5.987 12.385a.5.5 0 0 0 .602.602Q11 20 15 16l-3-3",
      "M15 9q4 4 7 0-3-4-7 0 4-4 0-7-4 3 0 7",
      "m8 15-2.58-2.58"
    ]
  },
  {
    "id": "sprout",
    "label": "Frisch",
    "d": [
      "M14 9.536V7a4 4 0 0 1 4-4h1.5a.5.5 0 0 1 .5.5V5a4 4 0 0 1-4 4 4 4 0 0 0-4 4c0 2 1 3 1 5a5 5 0 0 1-1 3",
      "M4 9a5 5 0 0 1 8 4 5 5 0 0 1-8-4",
      "M5 21h14"
    ]
  },
  {
    "id": "wheat-off",
    "label": "Glutenfrei",
    "d": [
      "m2 22 10-10",
      "m16 8-1.17 1.17",
      "M3.47 12.53 5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
      "m8 8-.53.53a3.5 3.5 0 0 0 0 4.94L9 15l1.53-1.53c.55-.55.88-1.25.98-1.97",
      "M10.91 5.26c.15-.26.34-.51.56-.73L13 3l1.53 1.53a3.5 3.5 0 0 1 .28 4.62",
      "M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4Z",
      "M11.47 17.47 13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
      "m16 16-.53.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.49 3.49 0 0 1 1.97-.98",
      "M18.74 13.09c.26-.15.51-.34.73-.56L21 11l-1.53-1.53a3.5 3.5 0 0 0-4.62-.28",
      "M2 2L22 22"
    ]
  },
  {
    "id": "milk-off",
    "label": "Laktosefrei",
    "d": [
      "M8 2h8",
      "M9 2v1.343M15 2v2.789a4 4 0 0 0 .672 2.219l.656.984a4 4 0 0 1 .672 2.22v1.131M7.8 7.8l-.128.192A4 4 0 0 0 7 10.212V20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-3",
      "M7 15a6.47 6.47 0 0 1 5 0 6.472 6.472 0 0 0 3.435.435",
      "M2 2L22 22"
    ]
  },
  {
    "id": "nut",
    "label": "Nüsse",
    "d": [
      "M16.847 5.847 20 9a7.23 7.23 0 011.551 7.516C21.241 17.352 21 17.932 21 19v1a1 1 0 01-1 1h-1c-1.069 0-1.648.242-2.485.552A7.2 7.2 0 019.002 20l-3.155-3.153",
      "M18.21 5.43c-1.71.69-5.07 1.07-6.71 1.07.46 1.38.91 2.74.61 4.88a.88.88 0 01-.73.74c-1.78.28-3.54-.17-4.88-.62 0 1.64-.38 5-1.07 6.71-.21.52-.82.55-1.17.12A10 10 0 0118.33 4.26c.43.35.4.97-.12 1.17",
      "M4.93 4.93 3 3a.7.7 0 010-1"
    ]
  },
  {
    "id": "egg",
    "label": "Ei",
    "d": [
      "M12 2C8 2 4 8 4 14a8 8 0 0 0 16 0c0-6-4-12-8-12"
    ]
  },
  {
    "id": "fish",
    "label": "Fisch",
    "d": [
      "M6.5 12c.94-3.46 4.94-6 8.5-6 3.56 0 6.06 2.54 7 6-.94 3.47-3.44 6-7 6s-7.56-2.53-8.5-6Z",
      "M18 12v.5",
      "M16 17.93a9.77 9.77 0 0 1 0-11.86",
      "M7 10.67C7 8 5.58 5.97 2.73 5.5c-1 1.5-1 5 .23 6.5-1.24 1.5-1.24 5-.23 6.5C5.58 18.03 7 16 7 13.33",
      "M10.46 7.26C10.2 5.88 9.17 4.24 8 3h5.8a2 2 0 0 1 1.98 1.67l.23 1.4",
      "m16.01 17.93-.23 1.4A2 2 0 0 1 13.8 21H9.5a5.96 5.96 0 0 0 1.49-3.98"
    ]
  },
  {
    "id": "shrimp",
    "label": "Meeresfrüchte",
    "d": [
      "M10 2a3.28 3.28 0 003.227 1.798l6.17-.561A1 1 0 1119.614 8H8.5a6.44 6.44 0 00-5.63 9.75A6.5 6.5 0 008.5 21c1.38 0 2-.5 2.5-1",
      "M10 8a8.5 8.5 0 000 8",
      "M11 22c-.5-.5-1.12-1-2.5-1a1 1 0 010-5H12a7 7 0 007-7V8",
      "M13 12h.01",
      "M8 16c-2 0-4.5-4-4-6"
    ]
  },
  {
    "id": "beef",
    "label": "Rind",
    "d": [
      "M16.4 13.7A6.5 6.5 0 1 0 6.28 6.6c-1.1 3.13-.78 3.9-3.18 6.08A3 3 0 0 0 5 18c4 0 8.4-1.8 11.4-4.3",
      "m18.5 6 1.754 3.5a6.48 6.48 0 0 1-1.854 8.2C15.4 20.2 11 22 7 22a3 3 0 0 1-2.68-1.66L2.4 16.5",
      "M10 8.5a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0Z"
    ]
  },
  {
    "id": "ham",
    "label": "Schwein",
    "d": [
      "M13.144 21.144A7.274 10.445 45 1 0 2.856 10.856",
      "M13.144 21.144A7.274 4.365 45 0 0 2.856 10.856a7.274 4.365 45 0 0 10.288 10.288",
      "M16.565 10.435 18.6 8.4a2.501 2.501 0 1 0 1.65-4.65 2.5 2.5 0 1 0-4.66 1.66l-2.024 2.025",
      "m8.5 16.5-1-1"
    ]
  },
  {
    "id": "drumstick",
    "label": "Geflügel",
    "d": [
      "M15.4 15.63a7.875 6 135 1 1 6.23-6.23 4.5 3.43 135 0 0-6.23 6.23",
      "m8.29 12.71-2.6 2.6a2.5 2.5 0 1 0-1.65 4.65A2.5 2.5 0 1 0 8.7 18.3l2.59-2.59"
    ]
  },
  {
    "id": "salad",
    "label": "Salat",
    "d": [
      "M19.496 12a2.5 2.5 0 00.399-2.214A2 2 0 0020.32 6.5 2 2 0 0019 3a2 2 0 00-1.5.68 2 2 0 00-3.287.424 2.5 2.5 0 00-3.189 2.06A3 3 0 0012 12l4-4",
      "M4 12a1 1 0 00-.99 1.133A9 9 0 0012 21a9 9 0 008.99-7.867A1 1 0 0020 12z",
      "M7 21h10",
      "M9.85 6.907A3.5 3.5 0 005.05 12"
    ]
  },
  {
    "id": "soup",
    "label": "Suppe",
    "d": [
      "M11.248 3c.273.1.808.53.747 1.36-.05.83-.938 1.2-.989 2.02-.06.78.333 1.24.727 1.62",
      "M16.252 3c.268.1.794.53.745 1.36-.06.83-.923 1.2-.993 2.02-.05.78.338 1.24.725 1.62",
      "M19.5 12 22 6",
      "M4 12a1 1 0 00-.99 1.133A9 9 0 0012 21a9 9 0 008.99-7.867A1 1 0 0020 12z",
      "M6.252 3c.268.1.794.53.745 1.36-.06.83-.923 1.2-.993 2.02-.05.78.338 1.24.735 1.62",
      "M7 21h10"
    ]
  },
  {
    "id": "cake-slice",
    "label": "Kuchen",
    "d": [
      "M16 13H3",
      "M16 17H3",
      "m7.2 7.9-3.388 2.5A2 2 0 0 0 3 12.01V20a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-8.654c0-2-2.44-6.026-6.44-8.026a1 1 0 0 0-1.082.057L10.4 5.6",
      "M7 7a2 2 0 1 0 4 0a2 2 0 1 0 -4 0Z"
    ]
  },
  {
    "id": "ice-cream-cone",
    "label": "Eis",
    "d": [
      "m7 11 4.08 10.35a1 1 0 0 0 1.84 0L17 11",
      "M17 7A5 5 0 0 0 7 7",
      "M17 7a2 2 0 0 1 0 4H7a2 2 0 0 1 0-4"
    ]
  },
  {
    "id": "cookie",
    "label": "Gebäck",
    "d": [
      "M11 17h.01",
      "M11.496 2c.324-.016.558.292.529.615a4 4 0 004.235 4.368.713.713 0 01.758.757 4 4 0 004.366 4.237c.323-.03.63.204.614.527a10 10 0 01-2.915 6.566A1 1 0 114.93 4.918 10 10 0 0111.496 2",
      "M12 12h.01",
      "M16 16h.01",
      "M16 3h.01",
      "M21 4h.01",
      "M21 8h.01",
      "M7 14h.01",
      "M9 8h.01"
    ]
  },
  {
    "id": "croissant",
    "label": "Frühstück",
    "d": [
      "M10.2 18H4.774a1.5 1.5 0 0 1-1.352-.97 11 11 0 0 1 .132-6.487",
      "M18 10.2V4.774a1.5 1.5 0 0 0-.97-1.352 11 11 0 0 0-6.486.132",
      "M18 5a4 3 0 0 1 4 3 2 2 0 0 1-2 2 10 10 0 0 0-5.139 1.42",
      "M5 18a3 4 0 0 0 3 4 2 2 0 0 0 2-2 10 10 0 0 1 1.42-5.14",
      "M8.709 2.554a10 10 0 0 0-6.155 6.155 1.5 1.5 0 0 0 .676 1.626l9.807 5.42a2 2 0 0 0 2.718-2.718l-5.42-9.807a1.5 1.5 0 0 0-1.626-.676"
    ]
  },
  {
    "id": "coffee",
    "label": "Kaffee",
    "d": [
      "M10 2v2",
      "M14 2v2",
      "M16 8a1 1 0 0 1 1 1v8a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V9a1 1 0 0 1 1-1h14a4 4 0 1 1 0 8h-1",
      "M6 2v2"
    ]
  },
  {
    "id": "wine",
    "label": "Wein",
    "d": [
      "M8 22h8",
      "M7 10h10",
      "M12 15v7",
      "M12 15a5 5 0 0 0 5-5c0-2-.5-4-2-8H9c-1.5 4-2 6-2 8a5 5 0 0 0 5 5Z"
    ]
  },
  {
    "id": "beer",
    "label": "Bier",
    "d": [
      "M17 11h1a3 3 0 0 1 0 6h-1",
      "M9 12v6",
      "M13 12v6",
      "M14 7.5c-1 0-1.44.5-3 .5s-2-.5-3-.5-1.72.5-2.5.5a2.5 2.5 0 0 1 0-5c.78 0 1.57.5 2.5.5S9.44 2 11 2s2 1.5 3 1.5 1.72-.5 2.5-.5a2.5 2.5 0 0 1 0 5c-.78 0-1.5-.5-2.5-.5Z",
      "M5 8v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8"
    ]
  },
  {
    "id": "cherry",
    "label": "Obst",
    "d": [
      "M2 17a5 5 0 0 0 10 0c0-2.76-2.5-5-5-3-2.5-2-5 .24-5 3Z",
      "M12 17a5 5 0 0 0 10 0c0-2.76-2.5-5-5-3-2.5-2-5 .24-5 3Z",
      "M7 14c3.22-2.91 4.29-8.75 5-12 1.66 2.38 4.94 9 5 12",
      "M22 9c-4.29 0-7.14-2.33-10-7 5.71 0 10 4.67 10 7Z"
    ]
  },
  {
    "id": "citrus",
    "label": "Zitrus",
    "d": [
      "M21.66 17.67a1.08 1.08 0 0 1-.04 1.6A12 12 0 0 1 4.73 2.38a1.1 1.1 0 0 1 1.61-.04z",
      "M19.65 15.66A8 8 0 0 1 8.35 4.34",
      "m14 10-5.5 5.5",
      "M14 17.85V10H6.15"
    ]
  },
  {
    "id": "star",
    "label": "Empfehlung",
    "d": [
      "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
    ]
  },
  {
    "id": "sparkles",
    "label": "Neu",
    "d": [
      "M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z",
      "M20 2v4",
      "M22 4h-4",
      "M2 20a2 2 0 1 0 4 0a2 2 0 1 0 -4 0Z"
    ]
  },
  {
    "id": "heart",
    "label": "Liebling",
    "d": [
      "M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"
    ]
  },
  {
    "id": "thumbs-up",
    "label": "Beliebt",
    "d": [
      "M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z",
      "M7 10v12"
    ]
  },
  {
    "id": "award",
    "label": "Ausgezeichnet",
    "d": [
      "m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526",
      "M6 8a6 6 0 1 0 12 0a6 6 0 1 0 -12 0Z"
    ]
  },
  {
    "id": "crown",
    "label": "Spezialität",
    "d": [
      "M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z",
      "M5 21h14"
    ]
  },
  {
    "id": "chef-hat",
    "label": "Vom Koch",
    "d": [
      "M17 21a1 1 0 0 0 1-1v-5.35c0-.457.316-.844.727-1.041a4 4 0 0 0-2.134-7.589 5 5 0 0 0-9.186 0 4 4 0 0 0-2.134 7.588c.411.198.727.585.727 1.041V20a1 1 0 0 0 1 1Z",
      "M6 17h12"
    ]
  },
  {
    "id": "house",
    "label": "Hausgemacht",
    "d": [
      "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8",
      "M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
    ]
  },
  {
    "id": "baby",
    "label": "Für Kinder",
    "d": [
      "M10 16c.5.3 1.2.5 2 .5s1.5-.2 2-.5",
      "M15 12h.01",
      "M19.38 6.813A9 9 0 0 1 20.8 10.2a2 2 0 0 1 0 3.6 9 9 0 0 1-17.6 0 2 2 0 0 1 0-3.6A9 9 0 0 1 12 3c2 0 3.5 1.1 3.5 2.5s-.9 2.5-2 2.5c-.8 0-1.5-.4-1.5-1",
      "M9 12h.01"
    ]
  },
  {
    "id": "snowflake",
    "label": "Kalt",
    "d": [
      "m10 20-1.25-2.5L6 18",
      "M10 4 8.75 6.5 6 6",
      "m14 20 1.25-2.5L18 18",
      "m14 4 1.25 2.5L18 6",
      "m17 21-3-6h-4",
      "m17 3-3 6 1.5 3",
      "M2 12h6.5L10 9",
      "m20 10-1.5 2 1.5 2",
      "M22 12h-6.5L14 15",
      "m4 10 1.5 2L4 14",
      "m7 21 3-6-1.5-3",
      "m7 3 3 6h4"
    ]
  },
  {
    "id": "clock",
    "label": "Dauert etwas",
    "d": [
      "M2 12a10 10 0 1 0 20 0a10 10 0 1 0 -20 0Z",
      "M12 6v6l4 2"
    ]
  },
  {
    "id": "percent",
    "label": "Angebot",
    "d": [
      "M19 5L5 19",
      "M4 6.5a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0Z",
      "M15 17.5a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0Z"
    ]
  }
];

export const tagIcon = (id: string | undefined): TagIcon | undefined => (id ? TAG_ICONS.find((i) => i.id === id) : undefined);
